import React, { useContext, useLayoutEffect, useRef } from "react";
import { SleepLogHttpServiceContext } from "../../components/shared/sleep-log-http-service.provider";
import { LoginStateContext } from "../../pages/app/login-state.context";
import useStore from "../store/useStoreService.hook";
import SleepLogSummariesService, { SleepLogSummariesState } from "./SleepLogSummariesService";

export const SleepLogSummariesServiceContext = React.createContext<SleepLogSummariesService | undefined>(undefined);

function useSleepLogSummariesServiceProvider() {
    const [loginState] = useContext(LoginStateContext);
    const sleepLogHttpService = useContext(SleepLogHttpServiceContext)!;
    const username = loginState.loggedIn ? loginState.username : "";

    const serviceRef = useRef<SleepLogSummariesService | undefined>(undefined);
    if (!serviceRef.current) {
        serviceRef.current = new SleepLogSummariesService(username, sleepLogHttpService);
    }

    const service = serviceRef.current;

    useLayoutEffect(() => {
        service.setUser(username);
    }, [service, username]);

    return service;
}

export function useSleepLogSummariesService() {
    return useStore<SleepLogSummariesService, SleepLogSummariesState>(SleepLogSummariesServiceContext);
}

export function SleepLogSummariesServiceProvider(props: { children: React.ReactNode }) {
    const service = useSleepLogSummariesServiceProvider();

    return (
        <SleepLogSummariesServiceContext.Provider value={service}>
            {props.children}
        </SleepLogSummariesServiceContext.Provider>
    );
}
